import axios from "axios";

const _axios = axios.create({
    baseURL: "/api"
});

export {_axios as http }
